//
import { RFormFields } from '@/components/reusable_components/next'
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

//
import ProviderModel from '@/models/Purchase/PchProvider'
const rulesId = (value) =>{
    if(!isNaN(value)){
      return true
    }
    else{
      return 'Campo Requerido'
    }
  }
//
export default props => new RFormFields(
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'rut',
            itemValue: 'id',
            label: 'Rut',
            model: ProviderModel,
            noObject: true,
            paramSearch: 'rut',
            rules: [ RequiredRule ],
        },
        trigger: props.pch_provider_trigger,
        variant: [ 0, 1 ],
    },
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'business_name',
            itemValue: 'id',
            label: 'Proveedor',
            model: ProviderModel,
            noObject: true,
            paramSearch: 'business_name',
            rules: [ RequiredRule ],
        },
        trigger: props.pch_provider_trigger,
        variant: [ 0, 1 ],
    },
    {
        name: 'pch_provider_branch_offices_id',
        type: 'select',
        props: {
            items: props.pch_provider_branch_offices,
            itemText: 'address',
            itemValue: 'id',
            label: 'Sucursal',
            noDataText: 'Sin sucursales',
            rules: [ RequiredRule ],
        },
        variant: [ 0, 1 ],
    },
    {
        name: 'emission_date',
        type: 'date-field',
        props: {
            label: 'Emision',
            rules: [ RequiredRule ],
        },
        variant: [ 0, 1 ],
    },
    {
        name: 'payment_date',
        type: 'date-field',
        props: {
            label: 'Pago',
            rules: [ RequiredRule ],
        },
        variant: [ 0, 1 ],
    },
    {
        name: 'credit_note_number',
        type: 'float-field',
        props: {
            label: 'N° Nota de credito',
            reverse: true,
            rules: [ RequiredRule ],
        },
        variant: [ 0, 1 ],
    },
    {
        name: 'document_type',
        type: 'select',
        props: {
            items: [
                {
                    text: 'Factura compra',
                    value: 0,
                },
                {
                    text: 'Nota debito',
                    value: 1,
                },
            ],
            label: 'Tipo documento',
        },
        variant: [ 0, 1 ],
    },
    {
        name: 'replacing_type',
        type: 'select',
        props: {
            items: [
                {
                    text: 'Anular factura',
                    value: 0,
                },
                {
                    text: 'Corregir monto',
                    value: 1,
                },
            ],
            label: 'Tipo remplazo',
            rules: [rulesId],
        },
        variant: [ 0 ],
    },
    {
        name: 'extra_tax',
        type: 'float-field',
        props: {
            label: 'Impuesto adicional',
        },
        variant: [ 0, 1 ],
    },
    {
        name: 'aux',
        type: 'divider',
        flex: {
            class: 'mb-3',
            xs12: true,
        },
        prependLabel: true,
        props: {
            label: props.document_type_title,
            rules: [ RequiredRule ],
        },
        variant: [ 0, 1 ],
    },
    {
        name: 'invoice_number',
        type: 'float-field',
        props: {
            label: 'N° Factura',
            reverse: true,
            rules: [ RequiredRule ],
        },
        variant: [ 0 ],
    },
    {
        name: 'debit_note_number',
        type: 'float-field',
        props: {
            label: 'N° Nota debito',
            reverse: true,
            rules: [ RequiredRule ],
        },
        variant: [ 1 ],
    },
    {
        name: 'net_total',
        type: 'currency-field',
        props: {
            label: 'Neto',
            reverse: true,
            rules: [ RequiredRule ],
        },
        variant: [ 0 ],
    },
    {
        name: 'iva',
        type: 'currency-field',
        props: {
            label: 'IVA',
            readonly: true,
            reverse: true,
        },
        variant: [ 0 ],
    },
    {
        name: 'total',
        type: 'currency-field',
        props: {
            label: 'Total',
            reverse: true,
            readonly: true,
        },
        variant: [ 0 ],
    },
)
